import { Control } from 'react-hook-form';
import { HelpCircle } from 'lucide-react';
import { useState } from 'react';
import { Input } from '@/components/ui/Input';

interface SocialMediaIntegrationSectionProps {
  control: Control<any>;
}

export default function SocialMediaIntegrationSection({
  control,
}: SocialMediaIntegrationSectionProps) {
  const [showHelper, setShowHelper] = useState(false);

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 bg-[#0A66C2] rounded-lg">
          <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
          </svg>
        </div>
        <h2 className="text-lg font-semibold">LinkedIn Integration</h2>
      </div>

      <div className="max-w-md space-y-1">
        <div className="flex items-center gap-1.5">
          <label className="block text-sm font-medium text-gray-700">Organization ID</label>
          <button
            type="button"
            className="text-gray-400 hover:text-gray-600 transition-colors"
            onClick={() => setShowHelper(!showHelper)}
            aria-label="How to find your LinkedIn Organization ID"
          >
            <HelpCircle className="w-3.5 h-3.5" />
          </button>
        </div>

        <Input
          name="linkedin_organization_id"
          control={control}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="e.g. 12345678"
          autoComplete="off"
          helperText="Enables 'Add to LinkedIn Profile' on certificates."
          rules={{ pattern: { value: /^\d*$/, message: 'LinkedIn Organization ID must be numeric' } }}
        />

        {showHelper && (
          <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-800">
            <p className="font-medium mb-1.5">How to find your Organization ID:</p>
            <ol className="list-decimal list-inside space-y-1 text-blue-700 text-xs">
              <li>Go to your company's LinkedIn page</li>
              <li>Click <span className="font-medium">Admin Tools</span></li>
              <li>The Organization ID is the number in the URL</li>
              <li>Example: linkedin.com/company/<span className="font-mono font-medium bg-blue-100 px-1 rounded">12345678</span>/admin</li>
            </ol>
          </div>
        )}
      </div>
    </div>
  );
}
